import React, { useState } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import Icon from 'components/Icon';

import styles from './styles.module.scss';

const DivinationForm = ({ onSubmit }) => {
	const [value, setValue] = useState('');

	const onClick = () => {
		if (value) {
			onSubmit(value);
		}
	};

	const onEnter = (event) => {
		event.preventDefault();
		const key = event.keyCode || event.which;

		if (key === 13) {
			if (value) {
				onSubmit(value);
			}
		}
	};

	return (
		<div>
			<form className={styles.DivinationForm__Search} onSubmit={onEnter}>
				<input
					{...{ value }}
					onChange={(event) => setValue(event.currentTarget.value)}
					className={styles.DivinationForm__Input}
					placeholder="Введите вопрос (не более 80 символов)"
				/>
				<button
					{...{ onClick }}
					active={!value}
					aria-label="Гадать"
					className={cx(styles.DivinationForm__Button, {
						[styles.DivinationForm__Button_disabled]: !value
					})}
					type="submit"
				>
					<Icon icon="check" className={styles.DivinationForm__ButtonIcon} />
				</button>
			</form>
		</div>
	);
};

DivinationForm.propTypes = {
	onSubmit: PropTypes.func.isRequired
};

export default DivinationForm;
